import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { Button, DialogContent, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { ModalComponent } from 'app/shared-components/modals/modalManager';
import { useState } from 'react';
import { getOfferSignUrls } from 'src/app/api/OffersApi';

export const KurvCompleteAccountDialog: ModalComponent<{ offerId: number }> = ({
  open,
  onClose,
  props,
}) => {
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    setLoading(true);
    try {
      const res = await getOfferSignUrls(props.offerId);
      if (res) {
        window.open(res.data.data.signUrl, '_blank');
        setLoading(false);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <AppSimpleDialog
      open={open}
      handleClose={onClose}
      title="Complete your account set up"
      size="sm"
      scroll="paper"
      disableScrollLock
      fullScreen={isMobile}
    >
      <Divider />
      <DialogContent className="px-24 flex flex-col">
        <p className="mb-24">
          Congratulations on starting your Kurv application for a merchant account! Before you
          finalize, we want to ensure you have everything in order. Double-check that all
          information provided is accurate and up-to-date to expedite the approval process. If you
          have any questions or need assistance, our support team is here to help. Thank you for
          choosing PayBlox for your payment processing needs!
        </p>
        <Button
          className="rounded-full bg-blue-primary px-14 hover:bg-blue-primary-hover text-white"
          type="submit"
          size="large"
          onClick={handleContinue}
          disabled={loading}
        >
          {loading ? 'loading...' : 'Continue'}
        </Button>
      </DialogContent>
    </AppSimpleDialog>
  );
};
